"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "14", height: "14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.875 5.125a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0zm8.179 3.31l.245-.344c.615-.865.95-1.89.95-2.966a5.126 5.126 0 10-5.124 5.125 5.094 5.094 0 002.966-.951l.344-.245 4.818 4.817a.435.435 0 00.618 0 .436.436 0 000-.618L9.054 8.435z", fill: "#404040" }))); };
exports.default = Component;
//# sourceMappingURL=Search.js.map